import React from "react";
import { Empty, Typography } from "antd";
import useHomePhoneProducts from "../../../../hooks/useHomePhoneProducts";
import { HomePhoneProduct } from "../../../../types/homePhone";
import { formatCurrency } from "../../../../utils/currency";
import ProductImage from "./components/ProductImage";
import ProductSkeleton from "./components/ProductSkeleton";
import "./index.scss";

const { Text } = Typography;

interface HomePhoneProps {
  selectedProductId?: string;
  onProductSelect: (product: HomePhoneProduct) => void;
}

const HomePhone: React.FC<HomePhoneProps> = ({
  selectedProductId,
  onProductSelect,
}) => {
  const { products, loading } = useHomePhoneProducts();

  return (
    <div className="home-phone-flow">
      <div className="home-phone-list">
        {loading ? (
          <ProductSkeleton />
        ) : products.length === 0 ? (
          <Empty description="No home phone products available" />
        ) : (
          products.map((product) => (
            <button
              key={product.id}
              type="button"
              className={`home-phone-product-row${
                selectedProductId === product.id ? " selected" : ""
              }`}
              aria-pressed={selectedProductId === product.id}
              onClick={() => onProductSelect(product)}
            >
              <ProductImage product={product} />
              <span className="home-phone-product-copy">
                <strong>{product.name}</strong>
                <Text>{product.description}</Text>
                <b>{formatCurrency(product.price || 0, product.currency)}</b>
              </span>
            </button>
          ))
        )}
      </div>
    </div>
  );
};

export default HomePhone;
